import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsFormDataConnectionsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-form-data-connections',
	path: '/jira/settings/forms/data-connections',
};
